/**
 * Returns a promise that resolves after the specified milliseconds
 */
export function sleep(milliseconds: number) {
    return new Promise<void>((resolve) => {
        setTimeout(resolve, milliseconds);
    });
}
